export enum ProvisionDurationEnum {
    MINIMAL = 'MINIMAL',
    SHORT = 'SHORT',
    BASIC = 'BASIC',
    MORE = 'MORE'
}
